import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvoicesService } from './services/invoices.service';
import { Auth } from 'aws-amplify';
import {
  folderStatuses,
  localImages,
  stringsList,
} from '../../../dashboard/constants/app-config';
import { MatDialog } from '@angular/material/dialog';
import { CreateFolderDialogComponent } from '../dialogs/create-folder-dialog/create-folder-dialog.component';
import { SmallDialogComponent } from '../../atoms/small-dialog/small-dialog.component';
import { TemplateRunDialogComponent } from '../../atoms/template-run-dialog/template-run-dialog/template-run-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { TemplateModel } from '../models/template.model';
import { TemplateService } from '../services/template.service';
import { FolderService } from './services/folder.service';
import { SubSink } from 'subsink';
import { fromEvent, of } from 'rxjs';
import { debounceTime, filter, map, switchAll, tap } from 'rxjs/operators';
import { TF } from 'src/app/API.service';
import { CreateInvoiceDialogComponent } from '../dialogs/create-invoice-dialog/create-invoice-dialog.component';
import { CreatedInvoiceService } from './services/created-invoice.service';
import { FolderPasswordService } from 'src/app/services/folder-password.service';
import { FolderPasswordDialogComponent } from '../dialogs/folder-password-dialog/folder-password-dialog.component';
import { SetFolderPasswordDialogComponent } from '../dialogs/set-folder-password-dialog/set-folder-password-dialog.component';
import { ClientService } from './services/client.service';
import { FileUploadService } from 'src/app/services/file-upload.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['../../styles/styles.css', './invoices.component.css'],
})
export class InvoicesComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public TF = TF;
  localImages = localImages;
  stringsList = stringsList;
  isCancelProgress = false;
  searchTemplateInput: string = '';
  folderStatuses = folderStatuses;
  sort: any = {
    name: '',
  };
  originalItems: any;
  items: any;
  newItems: any;
  invoices: any;
  activeSort: string = '';
  name: any;
  clientId: any;
  id: any;
  isLoading = false;
  user: any;
  isInvoices = false;
  folderStatus: any = null;
  downloadLink: any = null;
  folderId: any = null;
  isDownloadInProgress = false;
  isAdded = true;
  templates: any[] = [];
  fullTemplates: any[] = [];
  isTemplatesEmpty: boolean = false;
  showIcon = false;
  showClearIcon = false;
  isInputFocused = false;
  areWeinRunningProccess: boolean = false;
  isStatusLabelHidden: boolean = false;
  isStopScanningInProccess: boolean = false;
  isHovered: boolean = false;
  isSearchFilterOn: boolean = false;
  private nextToken: string | undefined;
  isAdditionalDataBeingFetched: boolean = false;
  userID!: string | null;

  // Tracks the index of the currently open dropdown, or null if no dropdown is open
  openDropdownIndex: number | null = null;

  // Tracks the index of the currently hovered row, or null if no row is hovered
  hoveredIndex: number | null = null;

  queryParams = {};

  isSearching: boolean = false;

  private savedScrollPosition = 0;
  @ViewChild('scrollableContainer')
  scrollableContainer!: ElementRef<HTMLElement>;

  // Add drag and drop related properties
  isDraggingFolder: boolean = false;
  dropTargetFolder: any = null;
  draggedFolder: any = null;

  // Add these properties at the top of the class with other properties
  private lastMovedItem: any = null;
  private lastMovedItemType: 'invoice' | 'folder' | null = null;
  private lastMovedItemSourceFolder: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public invoiceService: InvoicesService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private templateService: TemplateService,
    private folderService: FolderService,
    private input: ElementRef<HTMLInputElement>,
    private createdInvoiceService: CreatedInvoiceService,
    private clientService: ClientService,
    private fileUploadService: FileUploadService,
    public folderPasswordService: FolderPasswordService
  ) {
    const obs = fromEvent(this.input.nativeElement, 'keyup').pipe(
      map((e: any) => e.target.value),
      tap((searchInput: string) => {
        this.isSearchFilterOn = true;
        this.isSearching = true;
      }),
      map((searchInput: string) => searchInput.trim()),
      tap((searchInput) => {
        if (!searchInput.length) {
          this.clearSearch();
          this.isSearchFilterOn = false;
          this.isSearching = false;
        }
      }),
      filter((searchInput) => searchInput.length > 0),
      debounceTime(250)
    );

    obs.subscribe(async (searchInput: string) => {
      if (searchInput.length) {
        try {
          const searchResults = this.performLocalFuzzySearch(searchInput);
          this.items = this.sortFolders(searchResults);
        } catch (error) {
          console.error('Search error:', error);
        } finally {
          this.isSearching = false;
        }
      } else {
        this.clearSearch();
        this.isSearchFilterOn = false;
        this.isSearching = false;
      }
    });

    // Default sort by status
    this.toggleSort('status');
  }

  /**
   * Performs local fuzzy search on folders and their invoices
   * @param searchInput - The search query string
   * @returns Array of matching folders and invoices
   */
  private performLocalFuzzySearch(searchInput: string): any[] {
    const query = searchInput.toLowerCase();
    const results: any[] = [];
    const seenIds = new Set<string>();

    console.log(this.originalItems, "NOW");

    // Search through all folders and their nested invoices
    this.originalItems.forEach((folder: any) => {
      // Calculate folder name match score
      const folderScore = this.calculateFuzzyScore(folder.name || '', query);

      // Check if folder matches
      if (folderScore > 0.3) {
        if (!seenIds.has(folder.id)) {
          results.push({
            ...folder,
            type: 'folder',
            latestScanType: this.determineIfGoodsAndMaterial(folder),
            _searchScore: folderScore
          });
          seenIds.add(folder.id);
        }
      }

      // Search through invoices within the folder
      if (folder.invoices && folder.invoices.items) {
        folder.invoices.items.forEach((invoice: any) => {
          const invoiceScore = this.calculateFuzzyScore(invoice.title || '', query);

          if (invoiceScore > 0.3) {
            const invoiceId = invoice.id || `${folder.id}-${invoice.title}`;
            if (!seenIds.has(invoiceId)) {
              results.push({
                ...invoice,
                type: 'invoice',
                parentFolderName: folder.name,
                _searchScore: invoiceScore
              });
              seenIds.add(invoiceId);
            }
          }
        });
      }
    });

    // Sort by search score (higher scores first)
    return results.sort((a, b) => (b._searchScore || 0) - (a._searchScore || 0));
  }

  /**
   * Calculates fuzzy match score between text and query
   * @param text - The text to search in
   * @param query - The search query
   * @returns Score between 0 and 1 (higher is better match)
   */
  private calculateFuzzyScore(text: string, query: string): number {
    const textLower = text.toLowerCase();
    const queryLower = query.toLowerCase();

    // Exact match gets highest score
    if (textLower === queryLower) {
      return 1.0;
    }

    // Direct substring match gets high score
    if (textLower.includes(queryLower)) {
      return 0.9;
    }

    // Check if text starts with query
    if (textLower.startsWith(queryLower)) {
      return 0.85;
    }

    // Calculate Levenshtein distance for fuzzy matching
    const distance = this.levenshteinDistance(textLower, queryLower);
    const maxLength = Math.max(textLower.length, queryLower.length);

    // Normalize distance to a score (0-1)
    const normalizedScore = 1 - (distance / maxLength);

    // Only return meaningful scores (threshold 0.3)
    return normalizedScore > 0.6 ? normalizedScore : 0;
  }

  /**
   * Calculates Levenshtein distance between two strings
   * @param str1 - First string
   * @param str2 - Second string
   * @returns The edit distance between the strings
   */
  private levenshteinDistance(str1: string, str2: string): number {
    const len1 = str1.length;
    const len2 = str2.length;

    // Create a matrix to store distances
    const matrix: number[][] = Array(len1 + 1)
      .fill(null)
      .map(() => Array(len2 + 1).fill(0));

    // Initialize first column and row
    for (let i = 0; i <= len1; i++) {
      matrix[i][0] = i;
    }
    for (let j = 0; j <= len2; j++) {
      matrix[0][j] = j;
    }

    // Fill in the rest of the matrix
    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,      // deletion
          matrix[i][j - 1] + 1,      // insertion
          matrix[i - 1][j - 1] + cost // substitution
        );
      }
    }
    return matrix[len1][len2];
  }

  sortFolders(folders: any) {
    return folders.sort((a: any, b: any) => {
      const createdAtA = new Date(a.createdAt).getTime();
      const createdAtB = new Date(b.createdAt).getTime();

      return createdAtB - createdAtA;
    });
  }

  async ngOnInit(): Promise<void> {
    this.user = await Auth.currentAuthenticatedUser();
    this.userID = localStorage.getItem('userID');
    await this.getTemplates();
    await this.getFolders();

    this.activateSubscriptions();
    if (this.route.snapshot.queryParams.download_template == 'true') {
      this.openTemplateModal(this.route.snapshot.queryParams.id);
    }
    this.route.queryParams.subscribe((params) => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  /**
   * Toggles the dropdown open or closed.
   * @param index - The index of the row whose dropdown is being toggled.
   * @param state - The state of the dropdown (true for open, false for closed).
   */
  toggleDropdown(index: number, state: boolean) {
    this.openDropdownIndex = state ? index : null;
    this.hoveredIndex = state ? index : null;
  }

  /**
   * Handles the mouse over event for a row.
   * @param index - The index of the row being hovered over.
   */
  onMouseOver(index: number) {
    this.hoveredIndex = index;
  }

  /**
   * Handles the mouse leave event for a row.
   * @param index - The index of the row being left.
   */
  onMouseLeave(index: number) {
    // Only reset hoveredIndex to null if the dropdown is not open for the current row
    if (this.openDropdownIndex !== index) {
      this.hoveredIndex = null;
    }
  }

  filterInvoices(value: any) {
    // console.log(value, 'heh')
  }

  areFoldersDifferent(folders1: any[], folders2: any[]): boolean {
    // Check if the lengths are different first
    if (folders1?.length !== folders2?.length) {
      return true;
    }

    // Compare individual folder details
    for (let i = 0; i < folders1.length; i++) {
      if (!this.areFoldersEqual(folders1[i], folders2[i])) {
        return true;
      }
    }

    // If all folder details are the same, return false
    return false;
  }

  areFoldersEqual(folder1: any, folder2: any): boolean {
    return (
      folder1.name === folder2.name &&
      folder1.status === folder2.status &&
      folder1?.invoicesCount === folder2?.invoicesCount &&
      folder1.latestCompletedAt === folder2.latestCompletedAt
    );
  }

  toggleIcon() {
    this.showClearIcon = !!this.searchTemplateInput;
  }

  async clearSearch(): Promise<void> {
    this.searchTemplateInput = '';
    this.showClearIcon = false;
    // this.items = this.originalItems;

    this.items = this.originalItems.filter((f: any) => !f.parentFolderID);
  }

  async getTemplates() {
    this.isLoading = true;
    // First, get the cached templates from local storage
    const cachedTemplates = JSON.parse(
      localStorage.getItem('templates') || '[]'
    );
    if (cachedTemplates.length) {
      this.templates = this.sortTempaltes(cachedTemplates);
      //this.isLoading = false;
    } else {
      // this.isLoading = true;
    }

    // Send a request to fetch the latest templates
    let userId = localStorage.getItem('userID');
    const response = await this.templateService.ListTemplatesByClientID(
      userId as string
    );
    const newTemplates = response.items.map((el: any) => {
      el.template = JSON.parse(el.template);
      const keysArray = Object.keys(el.template);
      const keysAsStrings = keysArray.map((key) => String(key));

      let fullTemplate: any = {
        name: el.name,
        description: el.description,
      };
      let additionalFields: any = [];
      for (const [key, value] of Object.entries(el.template)) {
        if (this.templateService.isMandatoryKey(key)) {
          fullTemplate[key] = value;
        } else {
          additionalFields.push({ key: key, value: value });
        }
      }
      let template: TemplateModel = {
        id: el.id,
        _name: el.name,
        _description: el.description ? el.description : '',
        _updatedAt: el.updatedAt,
        _isFixedValueEnabled: el.isFixedValueEnabled,
        _fixedValues: el.fixedValues
      };
      this.fullTemplates.push({
        template: fullTemplate,
        additionalFields: additionalFields,
        orderedKeys: keysAsStrings,
        id: el.id,
      });
      return template;
    });

    // Check if the new templates are different from the cached templates
    const templatesChanged = this.areTemplatesDifferent(
      cachedTemplates,
      newTemplates
    );

    // If the templates have changed, update the local storage and the component's templates array
    if (templatesChanged) {
      localStorage.setItem('templates', JSON.stringify(newTemplates));
      this.templates = this.sortTempaltes(newTemplates);
    } else {
      // If the templates haven't changed, use the cached templates
      this.templates = this.sortTempaltes(cachedTemplates);
    }

    this.isLoading = false;
    this.isTemplatesEmpty = this.templates.length === 0;
  }

  areTemplatesDifferent(templates1: any[], templates2: any[]): boolean {
    // Check if the lengths of the arrays are different
    if (templates1.length !== templates2.length) {
      return true;
    }

    // Compare individual elements to check if anything inside is changed
    for (let i = 0; i < templates1.length; i++) {
      if (
        templates1[i].id !== templates2[i].id ||
        templates1[i]._name !== templates2[i]._name ||
        templates1[i]._description !== templates2[i]._description ||
        templates1[i]._updatedAt !== templates2[i]._updatedAt
      ) {
        return true;
      }
    }

    return false;
  }

  sortTempaltes(templates: any) {
    return templates.sort((a: any, b: any) => {
      const createdAtA = new Date(a._updatedAt).getTime();
      const createdAtB = new Date(b._updatedAt).getTime();
      return createdAtB - createdAtA;
    });
  }

  activateSubscriptions() {
    this.subs.sink = this.invoiceService
      .OnUpdateFolderListener(this.user.attributes.sub)
      .subscribe((folders: any) => {
        let foundFolder: any = this.items.find(
          (item: any) => item.id == folders.value.data.onUpdateFolder.id
        );

        this.invoiceService
          .getAllFolders(this.user.attributes.sub)
          .then((data) => {
            let foundFolderFromBackend: any = data.items.find(
              (item: any) => item.id == folders.value.data.onUpdateFolder.id
            );

            foundFolder = this.items.find(
              (item: any) => item.id == folders.value.data.onUpdateFolder.id
            );

            if (!foundFolder || !foundFolderFromBackend) return;

            foundFolder.type = 'folder';
            foundFolder.latestScanType =
              this.determineIfGoodsAndMaterial(foundFolder);

            if (
              foundFolderFromBackend?.invoices &&
              foundFolderFromBackend?.invoices?.items &&
              foundFolderFromBackend?.invoices?.items?.length > 0
            ) {
              foundFolder.invoices.items[0].extractedResults =
                foundFolderFromBackend.invoices.items[0].extractedResults;
              foundFolder.invoices.items[0].missingFields =
                foundFolderFromBackend.invoices.items[0].missingFields;
              foundFolder.invoices.items[0].extractedProductsResults =
                foundFolderFromBackend.invoices.items[0].extractedProductsResults;
            } else {
              foundFolder.invoices.items[0].extractedResults =
                foundFolderFromBackend?.invoices.items[0]?.extractedResults;
              foundFolder.invoices.items[0].missingFields =
                foundFolderFromBackend?.invoices.items[0]?.missingFields;
              foundFolder.invoices.items[0].extractedProductsResults =
                foundFolderFromBackend?.invoices.items[0]?.extractedProductsResults;
            }

            foundFolder.areThereMissingFields =
              folders.value.data?.onUpdateFolder?.areThereMissingFields;
            foundFolder.name = folders.value.data.onUpdateFolder.name;
            foundFolder.updatedAt = folders.value.data.onUpdateFolder.updatedAt;
            foundFolder.status = folders.value.data.onUpdateFolder.status;
            foundFolder.latestCompletedAt =
              folders.value.data.onUpdateFolder.latestCompletedAt;
            foundFolder.isLatestScanIncludedProducts =
              folders.value.data.onUpdateFolder.isLatestScanIncludedProducts;

            foundFolder.latestScanType =
              this.determineIfGoodsAndMaterial(foundFolder);
          })
          .catch((err) => {
            console.log(err);
          });
      });
  }

  toggleSort(key: string) {
    let val = '';
    if (!this.sort[key]) {
      this.sort[key] = val = 'desc';
    } else if (this.sort[key] == 'desc') {
      this.sort[key] = val = 'asc';
    } else {
      this.sort[key] = val = '';
    }
    this.sort = {};
    this.activeSort = key;
    this.sort[this.activeSort] = val;
  }

  refreshSort() {
    if (this.activeSort && this.sort[this.activeSort]) {
      const currentSort = { ...this.sort };
      this.sort = {};
      this.sort[this.activeSort] = currentSort[this.activeSort];

      // Sort the items array based on the current sort
      this.items = this.sortFolders(this.items);
    }
  }

  // async getFolders() {
  //   this.isLoading = true;

  //   // First, getting the cached folders from local storage
  //   const cachedFoldersJson = localStorage.getItem('folders');
  //   let cachedFolders: any;

  //   if (cachedFoldersJson !== 'undefined') {
  //     cachedFolders = cachedFoldersJson ? JSON.parse(cachedFoldersJson) : [];
  //   } else {
  //     cachedFolders = [];
  //   }

  //   if (cachedFolders?.length) {
  //     cachedFolders.forEach((item: any) => {
  //       item.type = 'folder';
  //       item.latestScanType = this.determineIfGoodsAndMaterial(item);
  //     });
  //     this.items = cachedFolders;
  //     this.isLoading = false;
  //   } else {
  //     this.isLoading = true;
  //   }

  //   // Sending a request to fetch the latest folders
  //   await this.invoiceService
  //     .getAllFolders(this.user.attributes.sub)
  //     .then((data) => {
  //       this.items = this.sortFolders(data.items).map((folder: any) => ({
  //         ...folder,
  //         type: 'folder',
  //         latestScanType: this.determineIfGoodsAndMaterial(folder),
  //       }));
  //       if (data.nextToken) {
  //         this.nextToken = data.nextToken;
  //       } else {
  //         this.nextToken = undefined;
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   // Checking if the new folders are different from the cached folders
  //   const foldersChanged = this.areFoldersDifferent(cachedFolders, this.items);

  //   // If the folders have changed, updating the local storage and the component's items array
  //   if (foldersChanged) {
  //     localStorage.setItem('folders', JSON.stringify(this.items));
  //   } else {
  //     // If the folders haven't changed, using the cached folders
  //     this.items = cachedFolders;
  //   }

  //   // Updating the hover and number properties for each item
  //   this.items?.forEach((item: any) => {
  //     item['hover'] = false;
  //     item.number = (item.invoices?.items?.length || 0) + '';
  //     item.latestScanType = this.determineIfGoodsAndMaterial(item);
  //   });

  //   this.originalItems = this.items;


  //   this.isLoading = false;
  // }

  async getFolders() {
    this.isLoading = true;

    // Get cached folders (for quick UI)
    const cachedFoldersJson = localStorage.getItem('folders');
    let cachedFolders: any[] = [];

    if (cachedFoldersJson && cachedFoldersJson !== 'undefined') {
      try {
        cachedFolders = JSON.parse(cachedFoldersJson);
      } catch {
        cachedFolders = [];
      }
    }

    if (cachedFolders.length > 0) {
      cachedFolders.forEach(folder => {
        folder.type = 'folder';
        folder.latestScanType = this.determineIfGoodsAndMaterial(folder);
      });

      // Only show parent folders visually
      this.items = cachedFolders.filter(f => !f.parentFolderID);
      this.isLoading = false;
    }

    // Fetch latest from backend
    try {
      const response = await this.invoiceService.getAllFolders(this.user.attributes.sub);

      // Normalize full folder list
      this.originalItems = this.sortFolders(response.items).map((folder: any) => ({
        ...folder,
        type: 'folder',
        latestScanType: this.determineIfGoodsAndMaterial(folder),
      }));

      // Visual display: only top-level folders
      this.items = this.originalItems.filter((f: any) => !f.parentFolderID);

      // Update pagination token
      this.nextToken = response.nextToken ?? undefined;

      // Compare with cache and update if changed
      const foldersChanged = this.areFoldersDifferent(cachedFolders, this.originalItems);
      if (foldersChanged) {
        localStorage.setItem('folders', JSON.stringify(this.originalItems));
      }

      // Add helper props for UI
      this.items.forEach((item: any) => {
        item.hover = false;
        item.number = (item.invoices?.items?.length || 0).toString();
      });
    } catch (err) {
      console.error(err);
    }

    this.isLoading = false;
  }

  determineIfGoodsAndMaterial(folder: any): string {
    return folder.isLatestScanIncludedProducts === TF.TRUE
      ? 'Goods and Material'
      : 'Regular';
  }

  async onScroll(e: any) {
    if (this.isSearchFilterOn) {
      return;
    }
    const scrollableContainer = this.scrollableContainer.nativeElement;
    const containerHeight = scrollableContainer.clientHeight;
    const scrollHeight = scrollableContainer.scrollHeight;
    const scrollTop = scrollableContainer.scrollTop;

    // Calculate the remaining distance to the bottom
    const remainToScrollToBottom = scrollHeight - (scrollTop + containerHeight);

    this.savedScrollPosition = scrollTop;

    // Define a threshold percentage (e.g., 90%) for triggering data loading
    const thresholdPercentage = 0.9;

    if (
      remainToScrollToBottom < containerHeight * thresholdPercentage &&
      !this.isAdditionalDataBeingFetched
    ) {
      this.isAdditionalDataBeingFetched = true;

      if (!this.nextToken) {
        return;
      }

      // Call your data fetching function here (replace this with your actual data fetching logic)
      await this.invoiceService
        // .getAllFolders(this.user.attributes.sub, "", this.nextToken)
        .getAllFolders(this.user.attributes.sub, this.nextToken)
        .then((data) => {
          this.items = this.items.concat(data.items);
          this.originalItems = this.items;
          if (data.nextToken) {
            this.nextToken = data.nextToken;
          } else {
            this.nextToken = undefined;
          }
          this.isAdditionalDataBeingFetched = false;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async getFoldersWithoutCaching() {
    this.isLoading = true;

    // First, get the cached folders from local storage
    const cachedFolders = JSON.parse(localStorage.getItem('folders') || '[]');
    // if (cachedFolders.length) {
    //   this.items = cachedFolders;
    //   this.isLoading = false;
    // } else {
    //   this.isLoading = true;
    // }

    // Send a request to fetch the latest folders
    await this.invoiceService
      .getAllFolders(this.user.attributes.sub)
      .then((data) => {
        this.items = this.sortFolders(data);
      })
      .catch((err) => {
        console.log(err);
      });

    // Check if the new folders are different from the cached folders
    const foldersChanged = this.areFoldersDifferent(cachedFolders, this.items);

    // If the folders have changed, update the local storage and the component's items array
    if (foldersChanged) {
      localStorage.setItem('folders', JSON.stringify(this.items));
    } else {
      // If the folders haven't changed, use the cached folders
      this.items = cachedFolders;
    }

    // Update the hover and number properties for each item
    this.items.forEach((item: any) => {
      item['hover'] = false;
      item.number = (item.invoices?.items?.length || 0) + '';
    });

    this.isLoading = false;
  }

  newFolder() {
    this.router.navigate(['/new-folder']);
  }

  cancelScan() {
    let dialogData = {
      heading: this.translate.instant('cancelScan'),
      contentPartOne: this.translate.instant('cancelScanPartOne'),
      contentPartTwo: this.translate.instant('cancelScanPartTwo'),
      action: this.translate.instant('cancelDialogAction'),
    };
    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response.action === stringsList.doAction) {
      }
    });
  }

  async deleteFolder(event: any, item: any) {
    event.stopPropagation();
    let dialogData = {
      heading: this.translate.instant('deleteFolder'),
      contentPartOne: this.translate.instant('folderContentPartOne'),
      contentFile: item.name,
      contentPartTwo: this.translate.instant('folderContentPartTwo'),
      action: this.translate.instant('Delete folder'),
      showCloseButton: false,
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response && response.action === stringsList.doAction) {
        await this.invoiceService
          .DeleteFolder({ id: item.id })
          .then(async (res) => {
            this.items = this.items.filter((item: any) => item.id !== res.id);
            this.snackBar.open(
              `The "${res.name}" folder has been deleted`,
              '',
              {
                duration: 5000,
                panelClass: ['white-snackbar'],
              }
            );
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  hoverEffectOn() {
    this.isCancelProgress = true;
  }
  hoverEffectOff() {
    this.isCancelProgress = false;
  }

  openSmallDialogProperties(data: any) {
    return {
      width: '480px',
      data: data,
    };
  }

  stopDefault(e: Event) {
    e.stopPropagation();
  }

  async openItem(item: any, event: any) {
    if (item.type === 'folder') {
      if (item.isPasswordProtected && !this.folderPasswordService.isUnlocked(item.id)) {
        const unlocked = await this.promptFolderPassword(item);
        if (!unlocked) return;
      }
      this.router.navigate(['invoices', item.id], {
        queryParams: this.queryParams,
      });
    } else if (item.type === 'invoice') {
      window.open(item.name, '_blank');
    }
  }

  async promptFolderPassword(folder: any): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(FolderPasswordDialogComponent, {
        width: '440px',
        disableClose: true,
        data: {
          folderName: folder.name,
          passwordHash: folder.passwordHash,
          folderId: folder.id,
        },
      });
      dialogRef.afterClosed().subscribe((result: boolean) => resolve(!!result));
    });
  }

  setFolderPassword(event: Event, item: any): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(SetFolderPasswordDialogComponent, {
      width: '460px',
      data: {
        folderId: item.id,
        folderName: item.name,
        isPasswordProtected: !!item.isPasswordProtected,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result || result.action === 'cancel') return;
      if (result.action === 'set') {
        item.isPasswordProtected = true;
        item.passwordHash = result.passwordHash;
      } else if (result.action === 'remove') {
        item.isPasswordProtected = false;
        item.passwordHash = null;
      }
    });
  }

  runFolder(folderID: string, item: any, isScanIncludedProducts: TF) {
    this.areWeinRunningProccess = true;
    this.isStatusLabelHidden = false;
    this.items = this.items.map((item: any) => {
      if (item.id === folderID) {
        return { ...item, status: 'IN_PROCESSING' };
      }
      return item;
    });
    this.invoiceService
      .CreateFolderScanTask({ folderID, isScanIncludedProducts })
      .then((res) => {
        this.areWeinRunningProccess = true;
      })
      .catch((err) => {
        console.log('err', err);
        this.areWeinRunningProccess = false;
      });
  }

  private isGoodsAndMaterialRequiredFile(fileName: string): boolean {
    const name = fileName?.toLowerCase() || '';
    return name.endsWith('.txt') || name.endsWith('.xlsx') || name.endsWith('.xls');
  }

  hasFilesRequiringGoodsAndMaterialProcessing(item: any): boolean {
    if (!item?.invoices?.items || item.invoices.items.length === 0) {
      return false;
    }
    return item.invoices.items.some((invoice: any) =>
      this.isGoodsAndMaterialRequiredFile(invoice?.name)
    );
  }

  runNano(folder: any) { }

  openDialogProperties() {
    return {
      width: '400px',
      height: '284px',
      data: {
        isEdit: false,
        currentFolders: this.items,
      },
    };
  }

  createFolder() {
    const dialogRef = this.dialog.open(
      CreateFolderDialogComponent,
      this.openDialogProperties()
    );
    dialogRef.afterClosed().subscribe((response: any) => {
      if (response) {
        // Add the new folder to items array
        this.items = [...this.items, response];
        // Apply current sort to the items array
        if (this.activeSort) {
          this.refreshSort();
        }
        this.snackBar.open(`Folder "${response.name}" has been created`, '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    });
  }

  createInvoice() {
    const dialogRef = this.dialog.open(CreateInvoiceDialogComponent, {
      width: '900px',
      maxHeight: '90vh',
      data: {
        folderId: null,
        folderName: null
      },
      panelClass: ['create-invoice-dialog-container'],
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(async (invoiceData) => {
      if (invoiceData) {
        try {
          // Get actual client ID from clientService
          const userId = this.userID || this.user?.attributes?.sub;
          if (!userId) {
            this.snackBar.open('Unable to get user information', '', {
              duration: 3000,
              panelClass: ['white-snackbar'],
            });
            return;
          }

          // Fetch the actual client to get the real clientID
          const client = await this.clientService.GetClient(userId);
          const clientId = client.id;
          
          if (!clientId) {
            this.snackBar.open('Unable to get client information', '', {
              duration: 3000,
              panelClass: ['white-snackbar'],
            });
            return;
          }

          // Get or create IZLAZNE FAKTURE folder at root level
          this.snackBar.open('Uploading and converting memorandum...', '', {
            duration: 10000,
            panelClass: ['white-snackbar'],
          });
          
          const izlazneFaktureFolderId = await this.createdInvoiceService.getOrCreateIzlazneFaktureFolder(clientId);

          // Upload memorandum, convert to PDF, and create the Invoice record
          await this.createdInvoiceService.handleMemorandumUpload(
            invoiceData.memorandumFile,
            izlazneFaktureFolderId,
            clientId,
            invoiceData,
            this.fileUploadService
          );

          this.snackBar.open(`Invoice ${invoiceData.invoiceNumber} created successfully in "${this.createdInvoiceService.IZLAZNE_FAKTURE_FOLDER}" folder`, '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });

          // Refresh folders to show the new IZLAZNE FAKTURE folder if it was just created
          await this.getFolders();
        } catch (error) {
          console.error('Error saving invoice:', error);
          this.snackBar.open('Error creating invoice. Please try again.', '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
        }
      }
    });
  }

  async openYourBooks() {
    try {
      const userId = this.userID || this.user?.attributes?.sub;
      if (!userId) {
        this.snackBar.open('Unable to get user information', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
        return;
      }

      const clientData = await this.clientService.GetClient(userId);
      const driveFileId = clientData?.cicDriveFileId;

      if (driveFileId) {
        const driveUrl = `https://docs.google.com/spreadsheets/d/${driveFileId}/edit`;
        window.open(driveUrl, '_blank');
      } else {
        this.snackBar.open('No CIC report found. Please run a report first.', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
      }
    } catch (error) {
      console.error('Error opening Your Books:', error);
      this.snackBar.open('Failed to open Your Books', '', {
        duration: 3000,
        panelClass: ['white-snackbar'],
      });
    }
  }

  generateFolderStatusLabel(status: any) {
    switch (status) {
      case folderStatuses.INIT:
      case folderStatuses.IN_QUEUE:
      case folderStatuses.IN_PROCESSING:
        return this.translate.instant('processStatuses.processing');
      case folderStatuses.SUCCESS:
        return this.translate.instant('processStatuses.completed');
      case folderStatuses.FAILED:
        return this.translate.instant('processStatuses.failed');
      default:
        return '';
    }
  }

  downloadFile(event: any, item: any) {
    this.stopDefault(event);
  }

  isProcessing(status: any) {
    if (
      status === folderStatuses.IN_PROCESSING ||
      status === folderStatuses.IN_QUEUE
    ) {
      return true;
    }
    return false;
  }

  generateFolderLabelColorClass(status: any) {
    return this.generateFolderStatusLabel(status)?.toLowerCase();
  }

  disableDownloadButton(isDownloadLink: any) {
    if (!isDownloadLink) {
      return true;
    }
    return false;
  }

  renderStatusComponent(isInvoice: any, status: any) {
    return isInvoice && status;
  }

  getStatus(item: any) {
    if (this.folderId && this.folderStatus && item.id === this.folderId) {
      return this.folderStatus;
    }
    return item.status;
  }

  getHasInvoice(item: any) {
    if (this.folderId && this.isInvoices && item.id === this.folderId) {
      return this.isInvoices;
    }

    return item.invoices.items.length !== 0;
  }

  getHasDownloadLink(item: any) {
    if (this.folderId && this.downloadLink && item.id === this.folderId) {
      return this.downloadLink;
    }

    return item.downloadLink;
  }

  async getZipFile(id: any, templateId: string) {
    this.invoiceService
      .GetFolder(id)
      .then((data: any) => {
        let selectedFolderInvoices: any = [];
        data.invoices.items.forEach((invoice: any) => {
          selectedFolderInvoices.push({
            invoiceName: invoice.name,
            folderID: id,
            templateID: templateId,
          });
        });
        this.invoiceService
          .RunFolder(selectedFolderInvoices)
          .then((data) => { })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => console.log(err));
  }

  isFolderClickable(e: any): boolean {
    const classList = e.target.classList;
    const isFolderWrapper = classList.contains('folder-wrapper');
    const isFolderName = classList.contains('folder-name');
    const isFolderNumber = classList.contains('folder-number');
    const isFolderNumberSpan = classList.contains('folder-number-span');
    const isLeftSideFolder = classList.contains('left-side-folder');
    const isRightSideFolder = classList.contains('right-side-folder');

    return (
      isFolderName ||
      isFolderNumber ||
      isFolderWrapper ||
      isFolderNumberSpan ||
      isLeftSideFolder ||
      isRightSideFolder
    );
  }

  openTemplateModal(folderID: any, event?: any) {
    this.stopDefault(event);
    const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
      width: '480px',
      data: {
        folderID: folderID,
        isTemplatesEmpty: this.isTemplatesEmpty,
        templatesList: this.templates,
      },
      panelClass: ['select-template-dialog'],
    });
    dialogRef.afterClosed().subscribe((res) => { });
  }

  openTemplateDialog(item: any) {
    let duplicatedArray = JSON.parse(JSON.stringify(item.invoices.items));
    duplicatedArray.forEach((item: any, index: any, array: any) => {
      item.missingFields = JSON.parse(item.missingFields);
    });
    this.openTemplateAndDownloadDialog(item.id, item, duplicatedArray);
    return;
  }

  openTemplateAndDownloadDialog(
    folderID: any,
    item?: any,
    duplicatedArray?: any[]
  ) {
    const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
      width: '480px',
      data: {
        folderID: folderID,
        folder: item,
        isTemplatesEmpty: this.isTemplatesEmpty, //this.isTemplatesEmpty, //treba ga prebaciti u dijalog
        templatesList: [], //this.templates,  //treba ga prebaciti u dijalog
        fullTemplates: [], //treba ga prebaciti u dijalog
        template: item, //treba ga samo poslati u dijalog, ovo je folder ustvari
        duplicatedArray: duplicatedArray, //treba ga samo poslati dijalog, ovo su ustvari invoices iz foldera
      },
      panelClass: ['select-template-dialog'],
    });

    dialogRef.afterClosed().subscribe((data) => { });
  }

  checkLengthOfInvoicesObj(item: any) {
    if (item.invoicesCount > 0) {
      return false;
    } else {
      return true;
    }
  }

  async stopScanning(folderID: string, folder: any) {
    let foundedFolder: any;
    let dialogData = {
      heading: this.translate.instant('Stop scanning invoices?'),
      contentPartOne: this.translate.instant(
        'Are you sure you want to stop scanning process?'
      ),
      // contentPartTwo: this.translate.instant('cancelScanPartTwo'),
      action: this.translate.instant('Stop scanning'),
    };
    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response.action === stringsList.doAction) {
        this.isStopScanningInProccess = true;
        await this.folderService
          .CancelFolderScanTask({
            folderID: folderID,
          })
          .then((res) => {
            this.isStatusLabelHidden = true;
            this.areWeinRunningProccess = false;
            this.isStopScanningInProccess = false;
            setTimeout(() => {
              this.snackBar.open('The scanning has been stopped', '', {
                duration: 5000,
                panelClass: ['white-snackbar'],
              });
            }, 2000);
          })
          .catch((err) => {
            this.isStatusLabelHidden = true;
            this.areWeinRunningProccess = false;
            this.isStopScanningInProccess = false;
          });
      }
    });
  }

  onFolderDragStarted(folder: any, event: DragEvent) {
    this.isDraggingFolder = true;
    this.draggedFolder = folder;
    this.setDragData(event, 'folder', folder);

    // Create a custom drag image
    const dragImage = document.createElement('div');
    dragImage.style.position = 'absolute';
    dragImage.style.top = '-1000px';
    dragImage.style.left = '-1000px';
    dragImage.style.padding = '8px 12px';
    dragImage.style.background = '#ffffff';
    dragImage.style.border = '2px solid #1e31cf';
    dragImage.style.borderRadius = '6px';
    dragImage.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
    dragImage.style.display = 'flex';
    dragImage.style.alignItems = 'center';
    dragImage.style.gap = '8px';
    dragImage.style.minWidth = '200px';
    dragImage.style.maxWidth = '400px';
    dragImage.style.whiteSpace = 'nowrap';
    dragImage.style.overflow = 'hidden';
    dragImage.style.textOverflow = 'ellipsis';

    // Add folder icon
    const icon = document.createElement('span');
    icon.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H10L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.8043 6.97933 22 7.45 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4Z" fill="#1e31cf"/>
      </svg>
    `;

    // Add folder name
    const name = document.createElement('span');
    name.textContent = folder.name;
    name.style.color = '#1e31cf';
    name.style.fontSize = '14px';
    name.style.fontWeight = '500';
    name.style.overflow = 'hidden';
    name.style.textOverflow = 'ellipsis';

    dragImage.appendChild(icon);
    dragImage.appendChild(name);
    document.body.appendChild(dragImage);

    // Set the custom drag image
    event.dataTransfer?.setDragImage(dragImage, 20, 20);

    // Clean up the drag image element after drag starts
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);
  }

  onFolderDragEnded() {
    this.isDraggingFolder = false;
    this.draggedFolder = null;
    this.dropTargetFolder = null;
  }

  onFolderDragOver(event: any, folder: any) {
    if (this.isDraggingFolder) {
      // Get the dragged item data
      const draggedData = event.dataTransfer?.getData(this.isDraggingFolder ? 'invoice' : 'folder');
      if (draggedData) {
        const data = window.JSON.parse(draggedData);

        if (this.isDraggingFolder && (data.id === folder.id || data.parentFolderID === folder.id)) {
          return; // Don't allow drop in same folder or its own subfolder
        }
      }

      event.preventDefault();
      this.dropTargetFolder = folder;
    }
  }

  onFolderDragLeave() {
    this.dropTargetFolder = null;
  }

  onFolderDrop(event: DragEvent, targetFolder: any) {
    event.preventDefault();
    this.dropTargetFolder = null;

    if (!event.dataTransfer) return;

    if (this.isDraggingFolder) {
      // Handle folder drop into another folder
      const folder = event.dataTransfer.getData('folder');
      if (folder) {
        const folderData = window.JSON.parse(folder);
        // Check if trying to drop into same folder or its own subfolder
        if (folderData.id === targetFolder.id || folderData.parentFolderID === targetFolder.id) {
          console.log('Cannot drop folder into itself or its own subfolder');
          return;
        }

        // Store the previous state for revert
        this.lastMovedItem = folderData;
        this.lastMovedItemType = 'folder';
        this.lastMovedItemSourceFolder = null; // Root level folder

        this.folderService.UpdateFolder({
          id: folderData.id,
          parentFolderID: targetFolder.id
        }).then(() => {
          const snackBarRef = this.snackBar.open('Folder moved successfully', 'Revert', {
            duration: 5000,
            panelClass: ['white-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            politeness: 'assertive',
            announcementMessage: 'Folder moved successfully. Click Revert to undo.'
          });

          snackBarRef.onAction().subscribe(() => {
            this.revertLastMove();
          });

          this.items = this.items.filter((item: any) => item.id !== folderData.id);
        });
      }
    }
  }

  private async revertLastMove() {
    if (!this.lastMovedItem || !this.lastMovedItemType) return;

    try {
      if (this.lastMovedItemType === 'folder') {
        await this.folderService.UpdateFolder({
          id: this.lastMovedItem.id,
          parentFolderID: this.lastMovedItemSourceFolder?.id || null // If source was root, set to null
        });

        // Refresh the folders list
        await this.getFolders();
      }

      this.snackBar.open('Move reverted successfully', '', {
        duration: 3000,
        panelClass: ['white-snackbar']
      });
    } catch (error) {
      console.error('Error reverting move:', error);
      this.snackBar.open('Failed to revert move', '', {
        duration: 3000,
        panelClass: ['red-snackbar']
      });
    }
  }

  private setDragData(event: DragEvent, type: 'invoice' | 'folder', data: any) {
    if (event.dataTransfer) {
      event.dataTransfer.setData(type, window.JSON.stringify(data));
    }
  }
}
